export default __webpack_public_path__ + "static/media/Logo_Footer.5372f1f5.png";